module.exports = __webpack_public_path__ + "static/media/xian.835a7af6.png";